(function($){
    //shipping_method_0_flexible_shipping_single18
    $(document).ready(function($) {
        $(document.body).on('updated_checkout', function() {
            $('#dpd_pickup_point_id_field, #dpd_pickup_point_id_field + a').hide();
            if($('[for="shipping_method_0_flexible_shipping_single9"]').prev('input').prop('checked') == true) {
                $('#shipdpd').remove();
                $('<div class="dpd-box" id="shipdpd">' + $('.dpd-box').html() + '</div>').insertAfter('[for="shipping_method_0_flexible_shipping_single9"]');
                setTimeout(function(){
                    set_dpd_desc();
                    // $('#shipinp .tt').html(text);
                }, 2000)
            }
        });
    });
    $('body').on('click', '.dpd-btn button', function(e){
        e.preventDefault();
        $('#dpd_pickup_point_id_field, #dpd_pickup_point_id_field + a').show();
    })
    $('body').on('change', '#dpd_pickup_point_id_field select', function(){
        set_dpd_desc();
    })
    function set_dpd_desc(){
        var value = $('#dpd_pickup_point_id_field select').val();
        var text = $('#dpd_pickup_point_id_field select option:selected').text();
        // $('#shipinp .subt').html(value);
        $('#shipdpd .tt').html($('#dpd_pickup_point_id_field select option:selected').html());
        $('#dpd_pickup_point_id_field, #dpd_pickup_point_id_field + a').insertAfter('#shipdpd');
    }
})(jQuery)